/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { ingest } from 'fierry/rpc/ingest';

import Batches from 'fierry/rpc/batches';


export default class Protocol
{
  constructor (client)
  {
    this.client = client;

    this.batches = new Batches();
  }


  onAttach (routing, notifications)
  {
    // no-op - ingest is keyed by notify; attach carries nothing we need.
  }


  onDetach (routing)
  {
    this.client.routes.detach(this.client.application, routing);
  }


  onNotify (routing, batch, data)
  {
    if (batch)
    {
      this.batches.push(batch, routing, data);

      return;
    }

    ingest(this.client.application, this.client.routes, [ { routing, data } ]);
  }


  onCreateBatch (id)
  {
    this.batches.create(id);
  }


  onCommitBatch (id)
  {
    for (const notifications of this.batches.commit(id))
    {
      ingest(this.client.application, this.client.routes, notifications);
    }
  }


  onCommand (command)
  {
    this.client.commands.complete(command);
  }


  finalize ()
  {
    this.client.notifyChanged();
  }


};
